import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StateManager } from '@/state/stateManager';
import { BaseSmartComponent } from './../base.component';
import { MessageService } from '@/services/message.service';
import { IChangeOrderModel } from '@/models/changeOrder.models';
import { DataManipulationService } from '@/services/dataManipulation.service';

@Component({
    selector: 'job-change-order-list',
    templateUrl: './jobChangeOrderList.template.html',
    host: {'class': 'job-change-order-list-component'}
})

export class JobChangeOrderListComponent extends BaseSmartComponent implements OnInit {
    public filterTerm: string = '';

    @Input()
    model: BehaviorSubject<Array<IChangeOrderModel>>;

    @Input()
    dataManager: DataManipulationService<IChangeOrderModel>;

    @Output()
    public addClicked: EventEmitter<any> = new EventEmitter();

    @Output()
    public itemSelected: EventEmitter<any> = new EventEmitter();

    public selectedChangeOrderId: string = null;

    constructor(private state : StateManager, messageService : MessageService) {
        super(messageService);
    }

    ngOnInit(): void {
        const self = this;

        self.watchSubscription(self.state.getActiveChangeOrder().subscribe((s) => {
            setTimeout(() => {
                if (s) {
                    self.selectedChangeOrderId = s.id;
                } else {
                    self.selectedChangeOrderId = null;
                }
            }, 0);
        }));
    }
};
